// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1Gwsi","content":"LayoutSettings_content__bRLLB"};